// extracted by mini-css-extract-plugin
export var grid = "steps-module--grid--51bf2";
export var gridWithRowGap = "steps-module--grid--with-row-gap--89c1b";
export var maxWidthContainer = "steps-module--max-width-container--22e23";
export var mt0 = "steps-module--mt-0--b41cb";
export var mt1 = "steps-module--mt-1--115fa";
export var mt2 = "steps-module--mt-2--4f229";
export var mt3 = "steps-module--mt-3--d9b99";
export var mt4 = "steps-module--mt-4--7b93d";
export var mt5 = "steps-module--mt-5--47333";
export var mt6 = "steps-module--mt-6--0847b";
export var removeVisuallyHidden = "steps-module--remove-visually-hidden--60ca4";
export var steps = "steps-module--steps--e333a";
export var steps__item = "steps-module--steps__item--4f8ff";
export var steps__item__icon = "steps-module--steps__item__icon--3c0a9";
export var steps__item__indicator = "steps-module--steps__item__indicator--73aa6";
export var steps__item__indicatorActive = "steps-module--steps__item__indicator--active--b4539";
export var steps__item__indicatorCompleted = "steps-module--steps__item__indicator--completed--7dfc8";
export var steps__item__indicatorLabel = "steps-module--steps__item__indicator-label--a8998";
export var steps__item__indicatorLabelActive = "steps-module--steps__item__indicator-label--active--032cd";
export var steps__item__label = "steps-module--steps__item__label--e27b4";
export var steps__item__line = "steps-module--steps__item__line--add42";
export var steps__item__lineCompleted = "steps-module--steps__item__line--completed--fdee0";
export var steps__list = "steps-module--steps__list--041ff";
export var visuallyHidden = "steps-module--visually-hidden--6aa51";
export var widgetBase = "steps-module--widget-base--2bc82";